module.exports = __webpack_public_path__ + "img/36.f0ec8380.svg";